export default "__VITE_ASSET__CLaZCVYy__"